import { getCookieValueFromConsent } from "./getCookieValueFromConsent"

export const cartupInitScript = (CARTUP_SPOTDY_KEY: string) => {
	return `SPOTDYLIBRARY.init(['${CARTUP_SPOTDY_KEY}'])`
};

export const icecatLiveScript = (PRIMARY_EAN: string) => {

	return ` IcecatLive.getDatasheet(
		{
		  'productstory': '#IcecatLive'
		},
		{
		  GTIN: '${PRIMARY_EAN}',   
		  UserName: 'MDMbeheer'
		}, 'nl');
		window.petOptions = {
			modules: {
				reviews: false
			}
			};`
};

export const showMoreLessDescriptionScript = () => `
	document.addEventListener("click", function (event) {
		if (
			event.target.matches("#show_more_description") ||
			event.target.matches(".shortContentShowDesc")
		) {
			const widget = event.target.closest(".content-recomnedation-widget");

			let slideDown = (target, duration=300) => {
					target.style.removeProperty('display');
					let display = window.getComputedStyle(target).display;
					if (display === 'none') display = 'block';
					target.style.display = display;
					let height = target.offsetHeight;
					target.style.overflow = 'hidden';
					target.style.height = 0;
					target.style.paddingTop = 0;
					target.style.paddingBottom = 0;
					target.style.marginTop = 0;
					target.style.marginBottom = 0;
					target.offsetHeight;
					target.style.boxSizing = 'border-box';
					target.style.transitionProperty = "height, margin, padding";
					target.style.transitionDuration = duration + 'ms';
					target.style.height = height + 'px';
					target.style.removeProperty('padding-top');
					target.style.removeProperty('padding-bottom');
					target.style.removeProperty('margin-top');
					target.style.removeProperty('margin-bottom');
					window.setTimeout( () => {
					target.style.removeProperty('height');
					target.style.removeProperty('overflow');
					target.style.removeProperty('transition-duration');
					target.style.removeProperty('transition-property');
					}, duration);
				}

			if (widget) {
				const fullContent = widget.querySelector(".longContentDataDiv");
				const longDesc = widget.querySelector(".longContentHideDesc");
				const shortDesc = widget.querySelector(".shortContentShowDesc");

				if (fullContent) {
					slideDown(fullContent, 300);
					if (longDesc) longDesc.style.display = "block";
					if (shortDesc) shortDesc.style.display = "none";
				}
			} else {
				document
					.querySelectorAll("#product_longdescription, .longContentDataDiv")
					.forEach(el => slideDown(el, 300));

				document
					.querySelectorAll("#show_more_description, .shortContentShowDesc")
					.forEach(el => el.style.display = "none");

				document
					.querySelectorAll("#show_less_description, .longContentHideDesc")
					.forEach(el => el.style.display = "block");
			}
		}
	});
	document.addEventListener("click", function (event) {
    if (
        event.target.matches("#show_less_description") ||
        event.target.matches(".longContentHideDesc")
    ) {
        const widget = event.target.closest(".content-recomnedation-widget");

        if (widget) {
            const longDescDiv = widget.querySelector(".longContentDataDiv");
            const longDescBtn = widget.querySelector(".longContentHideDesc");
            const shortDescBtn = widget.querySelector(".shortContentShowDesc");

            if (longDescDiv) longDescDiv.style.display = "none";
            if (longDescBtn) longDescBtn.style.display = "none";
            if (shortDescBtn) shortDescBtn.style.display = "block";
        } else {
            document
                .querySelectorAll(
                    "#product_longdescription, .longContentDataDiv, #show_less_description, .longContentHideDesc"
                )
                .forEach(el => el.style.display = "none");

            document
                .querySelectorAll("#show_more_description, .shortContentShowDesc")
                .forEach(el => el.style.display = "block");
        }
    }
});

`;

export const PDPDescriptionScrollIntoView = `
	document.addEventListener("click", function (event) {
    if (
        event.target.matches("#show_less_description") ||
        event.target.matches(".longContentHideDesc")
    ) {
       	const productDetailsTab = document.getElementById("product-details-tab-0");
	 	if(productDetailsTab !== null)productDetailsTab.scrollIntoViewIfNeeded({ behavior: "auto", block: "center"});
   		}
	});
	`;

export const categoryIntroShowMoreScripts = () => {
	return `
		document.addEventListener("click", function (event) {

    // Read More
    if (event.target.closest(".categoryIntroTextReadMore")) {
        document
            .querySelectorAll(".category-introduction-text")
            .forEach(el => {
                el.classList.add("remove-nowrap");
                el.classList.remove("category-text-inline");
            });

        document
            .querySelectorAll(".categoryIntroTextContentDiv")
            .forEach(el => el.classList.add("categoryIntroTextContentDiv-column"));

        document
            .querySelectorAll(".categoryIntroTextReadMore")
            .forEach(el => el.style.display = "none");

        document
            .querySelectorAll(".categoryIntroTextReadLess")
            .forEach(el => el.style.display = "block");
    }

    // Read Less
    if (event.target.closest(".categoryIntroTextReadLess")) {
        document
            .querySelectorAll(".category-introduction-text")
            .forEach(el => {
                el.classList.remove("remove-nowrap");
                el.classList.add("category-text-inline");
            });

        document
            .querySelectorAll(".categoryIntroTextContentDiv")
            .forEach(el => el.classList.remove("categoryIntroTextContentDiv-column"));

        document
            .querySelectorAll(".categoryIntroTextReadMore")
            .forEach(el => el.style.display = "block");

        document
            .querySelectorAll(".categoryIntroTextReadLess")
            .forEach(el => el.style.display = "none");
    }

});
`
}

export const flowboxScript = (FLOW_KEY: string, PAGETYPE: string, VALUE: string | string[]) => {
	
	return `
	(function(d, id) {
    	if (!window.flowbox) { var f = function () { f.q.push(arguments); }; f.q = []; window.flowbox = f; }
    	if (d.getElementById(id)) {return;}
    	var s = d.createElement('script'), fjs = d.scripts[d.scripts.length - 1]; s.id = id; s.async = true;
    	s.src = 'https://connect.getflowbox.com/flowbox.js';
    	fjs.parentNode.insertBefore(s, fjs);
  	})(document, 'flowbox-js-embed');
  
	var flowBoxInit = {
		key: '${FLOW_KEY}',
		locale: 'nl-NL',
	}
		
	if('${PAGETYPE}' === ''){
		flowBoxInit["container"] = '#js-flowbox-flow';
	}

	if('${PAGETYPE}' === 'COMUNITY_TAG_PAGE') {
		flowBoxInit["container"] = '#js-flowbox-flow';
		flowBoxInit["tags"] = '${VALUE}';
	}

	if('${PAGETYPE}' === 'PDP'){
		flowBoxInit["container"] = '#js-flowbox-flow_dynamic_pdp';
		flowBoxInit["productId"] = '${VALUE}';
	}

	if('${PAGETYPE}' === 'PLP'){
		flowBoxInit["container"] = '#js-flowbox-flow';
		flowBoxInit["tags"] = '${VALUE}';
	}
	window.flowbox('init', flowBoxInit)`
};

export const bazaarVoiceCallBackInpScript = (inputObj:any) => {
	return `
		window.bvCallback = function (BV) {
			BV.pixel.trackTransaction(${inputObj});
		};
	`;
}

export const magicZoomStartScript = (newZoomImageURL?:string,newSmallImageURL?:string, isMZInit?:boolean) => {
	return `
		if(${!isMZInit}){
			MagicZoom.start();
		}
		MagicZoom.update(document.querySelector("#pdpImage"), '${newZoomImageURL}', '${newSmallImageURL}')		
	`
};

export const klarnaRefreshExpressButton = () => {
	return `
		Klarna.ExpressButton.refreshButtons(); 
	`
}

export const klarnaRefreshPlacement = () => {
	return `
	window.Klarna && window.Klarna.OnsiteMessaging && window.Klarna.OnsiteMessaging.refresh && window.Klarna.OnsiteMessaging.refresh();
	`
}

export const loadHeaderUSP = `
			var headerUSP = document.querySelector('.header-usps');
			if(headerUSP){
				var headeUSPBlocks = [...document.getElementsByClassName('usp-block')];
				headeUSPBlocks.forEach((uspBlock)=>{
					uspBlock.classList.add("header-usp-hide-mobile");
				})
				headerUSP.classList.remove("hide-mobile");
				var currentUsp = 0;
				hideShowHeaderUSP()
				if(hideShowHeaderUSPIntervalId)clearInterval(hideShowHeaderUSPIntervalId);
				var hideShowHeaderUSPIntervalId = setInterval(hideShowHeaderUSP,3000);
				function hideShowHeaderUSP(){
					headeUSPBlocks[currentUsp].classList.add("header-usp-hide-mobile");
					currentUsp++;
					if(currentUsp===headeUSPBlocks.length){
						currentUsp=0;
					}
					headeUSPBlocks[currentUsp].classList.remove("header-usp-hide-mobile");
				}
			} `;

export const flowBoxCheckoutScript = (inputObj:any) => {
	return `window.flowboxCheckout.checkout(${JSON.stringify(inputObj)});	`;
}

export const helloRetailInitScript = (helloRetailUUID:string, marketingCookie:boolean) => {
		return	marketingCookie ? `
				window.hrq = window.hrq || [];
				hrq.push(
					[
						'init', 
						{
							websiteUuid: "${helloRetailUUID}",
						}
					]
				);

			`
			:
			`
			window.hrq = window.hrq || [];
				hrq.push(
					[
						'init', 
						{
							websiteUuid: "${helloRetailUUID}",
							trackingOptOut: "true"
						}
					]
				);
			`
}

export const helloRetailReloadScript = (helloRetailUUID:string) => {
		return	`
				window.hrq = window.hrq || [];
				hrq.push([ "reload", { websiteUuid: "${helloRetailUUID}" } ]);
			`
}

export const cookiebotGtmFallbackScript = () => (`((d,s,c)=>{
					if(!/^((?!chrome|android).)*safari/i.test(navigator.userAgent))return;
					const e=d.createElement(s),r=d.getElementsByTagName(s)[0];e.id="Cookiebot";
					e.type="text/javascript";e.src="https://consent.cookiebot.com/uc.js";e.dataset.
					cbid=c;e.async=true;r.parentNode.insertBefore(e,r);})(document, "script", 
					"cbid=cc84a704-55c7-4a2e-93a4-112dbb5d8cf0")`);